module.exports = __webpack_public_path__ + "img/20190601135308286.d04b76e3.png";